import { Button } from "@/components/ui/UIElements/Button";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../";

const BusinessInfoModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Business Integration Information"
      size="md"
      className="ordering-catalog-surface"
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="bg-primary/10 flex h-8 w-8 items-center justify-center rounded-full">
              <svg
                className="text-primary h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <div className="flex-1">
            <h3 className="mb-2 text-lg font-medium text-white">
              Connect Your POS System
            </h3>
            <p className="text-foreground leading-relaxed">
              Connect with any of our available integrations with a few steps.
              Open the store where you want to connect your POS to our system.
              Configure the integration settings with your own keys and sync
              your products and stores to your POS or to our dashboard.
            </p>
            <p className="text-foreground mt-3 leading-relaxed">
              <span className="font-medium text-white">Need Help?</span> Our
              support team is available to help you set up integrations and
              answer any questions you may have.
            </p>
          </div>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <Button
            variant="ghost"
            onClick={onClose}
            className="border-border bg-card text-foreground hover:bg-secondary focus:ring-ring rounded-md border px-4 py-2 text-sm font-medium focus:ring-2 focus:ring-offset-2 focus:outline-none"
          >
            Close
          </Button>
          <Button
            variant="ghost"
            onClick={() => {
              // Navigate to support page using React Router
              navigate("/support");
            }}
            className="bg-primary hover:bg-primary/90 focus:ring-ring rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white focus:ring-2 focus:ring-offset-2 focus:outline-none"
          >
            Contact Support
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BusinessInfoModal;
